import type { InjectionKey } from 'vue'

import type { ProvideResolutionFlowMachine } from '~/scopes/customer-care/resolution/machine/ResolutionFlow.machine.types'

export const ResolutionFlowStateMachineKey = Symbol(
  'resolutionFlowStateMachine',
) as InjectionKey<ProvideResolutionFlowMachine>
